/* const SECURED_BASE_URI = "https://api.cardfabric.com/v1/"
const UNSECURED_BASE_URI = "https://api.cardfabric.com/v1/"
const BASE_API_URI = "https://api.cardfabric.com/v1/"
const BRANDING_LOGIN_IMAGE_UPLOAD_URI = "https://api.cardfabric.com/v1/secured/image/branding/login/reseller"
const BRANDING_GENERAL_IMAGE_UPLOAD_URI = "https://api.cardfabric.com/v1/secured/image/branding/general/reseller" */

const SECURED_BASE_URI = "http://localhost:3000/v1/"
const UNSECURED_BASE_URI = "http://localhost:3000/v1/"
const BASE_API_URI = "http://localhost:3000/v1/"
const BRANDING_LOGIN_IMAGE_UPLOAD_URI = "http://localhost:3000/v1/secured/image/branding/login/reseller"
const BRANDING_GENERAL_IMAGE_UPLOAD_URI = "http://localhost:3000/v1/secured/image/branding/general/reseller"

export default {
  SECURED_BASE_URI: SECURED_BASE_URI,
  UNSECURED_BASE_URI: UNSECURED_BASE_URI,
  BASE_API_URI: BASE_API_URI,
  BRANDING_LOGIN_IMAGE_UPLOAD_URI: BRANDING_LOGIN_IMAGE_UPLOAD_URI,
  BRANDING_GENERAL_IMAGE_UPLOAD_URI: BRANDING_GENERAL_IMAGE_UPLOAD_URI
}
